import { useEffect } from 'react';
import { useBreadcrumbs } from '../providers/breadcrumbs/BreadcrumbContext';

/**
 * Hook for pages to hide specific breadcrumb sections by route subsection key
 * @param concealedSections - Array of route subsection keys to hide from breadcrumbs
 */
export const useBreadcrumbConcealment = (concealedSections: string[]) => {
  const { setConcealedSections } = useBreadcrumbs();

  useEffect(() => {
    // Set the concealed sections when the component mounts or sections change
    setConcealedSections(concealedSections);

    // Cleanup function to clear concealed sections when component unmounts
    return () => {
      setConcealedSections([]);
    };
  }, [concealedSections, setConcealedSections]);

  return {
    setConcealedSections,
  };
};
